import { render, staticRenderFns } from "./patternColorFillSolid.vue?vue&type=template&id=90ccc080&"
import script from "./patternColorFillSolid.vue?vue&type=script&lang=ts&"
export * from "./patternColorFillSolid.vue?vue&type=script&lang=ts&"
import style0 from "./patternColorFillSolid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports